/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DateTimeCriteriaRangeResponse
 */
export interface DateTimeCriteriaRangeResponse {
    /**
     * 
     * @type {Date}
     * @memberof DateTimeCriteriaRangeResponse
     */
    from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof DateTimeCriteriaRangeResponse
     */
    to?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof DateTimeCriteriaRangeResponse
     */
    exclude?: boolean;
}

export function DateTimeCriteriaRangeResponseFromJSON(json: any): DateTimeCriteriaRangeResponse {
    return DateTimeCriteriaRangeResponseFromJSONTyped(json, false);
}

export function DateTimeCriteriaRangeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DateTimeCriteriaRangeResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'from': !exists(json, 'from') ? undefined : (new Date(json['from'])),
        'to': !exists(json, 'to') ? undefined : (new Date(json['to'])),
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
    };
}

export function DateTimeCriteriaRangeResponseToJSON(value?: DateTimeCriteriaRangeResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'from': value.from === undefined ? undefined : (value.from.toISOString()),
        'to': value.to === undefined ? undefined : (value.to.toISOString()),
        'exclude': value.exclude,
    };
}


